import { render, staticRenderFns } from "./URLNotFound.vue?vue&type=template&id=1f62d66b&lang=html&"
import script from "./URLNotFound.vue?vue&type=script&lang=js&"
export * from "./URLNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports